import { createSlice } from "@reduxjs/toolkit";
import { authService } from "../../../Api/Services/AuthService/AuthService";
import { IMisCreateUserData } from "../../../Types/Auth";
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";
import { ILoginInitialState } from "../../../features/login/types";

// Initial state for authentication (login and user creation)
const initialState: ILoginInitialState = {
  loginDetails: null, // To store login details after successful login
  createMisUser: null, // To store created user details after successful registration
  loading: false, // To track loading status of API calls
  error: null, // To track error messages in case of failure
};

export const createMisUserAccount = createServiceAsyncThunk<any, any>(
  "/mis/user-register",
  (createUserData: IMisCreateUserData) => authService.register(createUserData),
  "User Register Failed"
);

// Slice to handle authentication-related actions and state changes
const AuthSlice = createSlice({
  name: "authLogin", // Slice name
  initialState, // Initial state defined above
  reducers: {
    clearRegisterAccountErrors: (state) => {
      state.error = null;
    },
    clearSuccessMisAccount: (state) => {
      state.createMisUser = null;
    },
  },
  extraReducers: (builder) => {
    // Handles the MIS user account creation process
    builder.addCase(createMisUserAccount.pending, (state) => {
      state.loading = true; // Set loading to true when the request starts
      state.error = null; // Clear any previous errors
    });
    builder.addCase(createMisUserAccount.fulfilled, (state, action: any) => {
      state.loading = false; // Set loading to false when the request is completed
      state.createMisUser = action.payload; // Store the created user details in the state
    });
    builder.addCase(createMisUserAccount.rejected, (state, action: any) => {
      state.loading = false; // Set loading to false when the request fails
      state.error = action.payload; // Store the error message in state
    });
  },
});

export const { clearRegisterAccountErrors, clearSuccessMisAccount } =
  AuthSlice.actions;

// Export the reducer to be used in the store
export default AuthSlice.reducer;
